import axios from '@/axios'

const upload = file => {
	const path = `/media_objects`

	const headers = {
		'Content-Type': 'multipart/form-data'
	}

	return axios.post(path, file, { headers })
}

export default {
	upload
}
